export const statusIdentifier = (id) => {
    switch (id) {
        case 0:
            return { status: 'Pending', colorClass: 'text-yellow-500' };
        case 1:
            return { status: 'Completed', colorClass: 'text-green-500' };
        case 2:
            return { status: 'Rejected', colorClass: 'text-pink-400' };
        case 3:
            return { status: 'Accepted', colorClass: 'text-orange-500' };
        case 4:
            return { status: 'In Progress', colorClass: 'text-blue-500' };
        default:
            return { status: '-', colorClass: 'text-yellow-500' };
    }
};

export const adminActionIdentifier = (status) => {
    switch (status) {
        case 'NO_FAVOR':
            return 'No Favor'
        case 'PARTIAL':
            return 'Partial'
        case 'FAVOR_USER':
            return 'Favor User'
        case 'FAVOR_PROVIDER':
            return 'Favor Provider'
        default:
            return '-'
    }
}